import BlogCard from "src/components/Shared/BlogCard";

export default function BlogsContent({ blogData, style, color }) {
  return (
    <div className="w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-[13px] gap-y-10 sm:gap-y-[76px] pt-10 sm:pt-[112px]">
      {blogData?.map((data, idx) => (
        <BlogCard
          img={
            data.image
              ? data.image
              : "/site-assets/placeholders/img-placeholder.jpg"
          }
          category={data.content_type}
          title={data.title}
          info={data.description}
          key={idx}
          url_slug={data?.url_slug}
          color={color}
          style={style}
        />
      ))}
    </div>
  );
}
